module.exports = __webpack_public_path__ + "static/media/referral-icon.5b189474.svg";